import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from './firebase';

export const AUTH_KEY = 'kutugoo_user';

export const login = async (phone, password) => {
  try {
    // Businesses koleksiyonundan phone ile arama
    const q = query(
      collection(db, 'businesses'), 
      where('phone', '==', phone)
    );
    
    const querySnapshot = await getDocs(q);
    
    if (querySnapshot.empty) {
      return { success: false, error: 'Telefon numarası bulunamadı' };
    }
    
    let businessData = null;
    querySnapshot.forEach((doc) => {
      const data = doc.data();
      if (data.pass === password) {
        businessData = { id: doc.id, ...data };
      }
    });
    
    if (!businessData) {
      return { success: false, error: 'Şifre hatalı' };
    }
    
    // Başarılı giriş - localStorage'a kaydet
    const userData = {
      phone: businessData.phone,
      businessId: businessData.id,
      businessName: businessData.name,
      loginTime: new Date().toISOString()
    };
    
    localStorage.setItem(AUTH_KEY, JSON.stringify(userData));
    
    // Debug log ekle
    console.log('Login successful, businessId:', businessData.id);
    
    return { success: true, user: userData };
    
  } catch (error) {
    console.error('Giriş hatası:', error);
    return { success: false, error: 'Giriş sırasında hata oluştu' };
  }
};

export const logout = () => {
  localStorage.removeItem(AUTH_KEY);
};

// Cache için global değişken
let currentUserCache = null;
let lastCacheTime = 0;
const CACHE_DURATION = 5000; // 5 saniye cache

export const getCurrentUser = () => {
  if (typeof window === 'undefined') return null;
  
  const now = Date.now();
  
  // Cache varsa ve yeterince yakınsa kullan
  if (currentUserCache && (now - lastCacheTime) < CACHE_DURATION) {
    return currentUserCache;
  }
  
  try {
    const userData = localStorage.getItem(AUTH_KEY);
    if (userData) {
      currentUserCache = JSON.parse(userData);
      lastCacheTime = now;
      
      // Debug log
      console.log('getCurrentUser returning:', currentUserCache);
      
      return currentUserCache;
    }
  } catch (error) {
    console.error('Error parsing user data:', error);
    localStorage.removeItem(AUTH_KEY);
  }
  
  currentUserCache = null;
  return null;
};

export const isLoggedIn = () => {
  return getCurrentUser() !== null;
};

// Cache'i temizle
export const clearUserCache = () => {
  currentUserCache = null;
  lastCacheTime = 0;
};